(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/step-indicator-balls/react/prescript.js') >= 0) return;  svs.modules.push('/components/tb-ui/step-indicator-balls/react/prescript.js');

'use strict';

svs = svs || {};
svs.components = svs.components || {};
svs.components.tb_ui = svs.components.tb_ui || {};
svs.components.tb_ui.stepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls || {};
svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls || {};

 })(window);